module.exports = __webpack_public_path__ + "static/media/kits_logo.fd223d39.png";